import React, { useEffect, useRef, useState } from "react"
import useToggle from "../../../../hooks/toggle";
import { selecteddocumentesign } from "../ReviewDocs";
import Esign from "../Esign";
import { useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import { ALAMultiOffer, getexternaldocuments, getSavedOfferDetails } from "../../../../api/transaction";
import { useReactToPrint } from 'react-to-print';
import { CSpinner } from "@coreui/react";
const ALAmultipleoffer = ()=>{
const {id,user}:any = useParams()
const componentRef = useRef();
const[multipleoffer,setMultipleoffer] = useState({
  offer_id :id,
  agreement_date :null,
  known_as :"",
  seller_by :"",
  up_maximum :false,
  up_maximum_price_of:"",
  an_unlimited :false,
  an_unlimited_hourof :"",
  selected :false,
  not_selected :false,
  final_price_amount :'',
  american_home_shield :false,
  two_ten_home_warranty :false,
  other :false,
  other_value :"",
  seller1_signature :"",
  seller1_signature_date :null,
  seller2_signature :"",
  seller2_signature_date :null,
  buyer1_signature :"",
  buyer1_signature_date :null,
  buyer2_signature :"",
  buyer2_signature_date :null,

})
 // @ts-ignore
 const val = useSelector((state)=>state?.new?.signset)
const [canvasmodal, setCanvasModal] = useToggle(false);
const [htmlContent, setHtmlContent] = useState("");
const [offerdetails, setOfferDetails] = useState({});
const [selecteddocumentesign, setselectedDocumentEsign] = useState<selecteddocumentesign>({
    offerid : "",
  document_name: "",
  image_base64: "",
  sign_role: 1
  })
  const [loader,setloading] = useState(false)
  const printf = () => {
    // window.print()
    handlePrint()
};
useEffect(()=>{
  if(val){
    if(user == "seller"){
      setMultipleoffer({ ...multipleoffer, seller1_signature: val })
    }
    if(user == "client"){
      setMultipleoffer({ ...multipleoffer, buyer1_signature: val })
    }
  }
  },[val])

  const send = async() => {
    setloading(true)
    if(user==="seller"){
    
   
           if(multipleoffer?.seller1_signature){
               let res = await ALAMultiOffer(multipleoffer)
               if(res?.status == "success"){
                alert("Submitted Successfully")
            }
            else{
                alert("Something went wrong")
            }
           }
       }
       else if(user==="client"){
          
        
           if(multipleoffer?.buyer1_signature){
               let res = await ALAMultiOffer(multipleoffer)
               if(res?.status == "success"){
                alert("Submitted Successfully")
            }
            else{
                alert("Something went wrong")
            }
           }
       }
       setloading(false)
};

useEffect(()=>{
  (async function(){
    let offerdetails = await getSavedOfferDetails(id)
    setOfferDetails(offerdetails[0])
    const res =await getexternaldocuments(id,"multipleoffer") 
    setMultipleoffer({...multipleoffer,
      known_as :res?.data?.known_as,
      seller_by :res?.data?.seller_by,
      agreement_date :res?.data?.agreement_date,
      up_maximum :res?.data?.up_maximum,
      up_maximum_price_of:res?.data?.up_maximum_price_of,
      an_unlimited :res?.data?.an_unlimited,
      an_unlimited_hourof :res?.data?.an_unlimited_hourof,
      selected :res?.data?.selected,
      not_selected :res?.data?.not_selected,
      final_price_amount :res?.data?.final_price_amount,
      american_home_shield :res?.data?.american_home_shield,
      two_ten_home_warranty :res?.data?.two_ten_home_warranty,
      other :res?.data?.other,
      other_value :res?.data?.other_value,
      seller1_signature :res?.data?.seller1_signature,
      seller1_signature_date :res?.data?.seller1_signature_date,
      seller2_signature :res?.data?.seller2_signature,
      seller2_signature_date :res?.data?.seller2_signature_date,
      buyer1_signature :res?.data?.buyer1_signature,
      buyer1_signature_date :res?.data?.buyer1_signature_date,
      buyer2_signature :res?.data?.buyer2_signature,
      buyer2_signature_date :res?.data?.buyer2_signature_date,
    })
  })()
},[])
const handlePrint = useReactToPrint({
  content: () => componentRef.current,
});


    return (
        <>
        <table
  style={{ width: 1100, margin: "0 auto", background: "#fff", padding: 30 }} ref={componentRef}
>
  <tbody>
    <tr>
      <td>
        <table style={{ width: "100%" }}>
          <tbody>
            <tr>
              <td style={{ width: "90%" }}>
                <img
                  style={{ width: 250 }}
                  src="https://storagemilforddev.blob.core.windows.net/images/logo.svg"
                />
              </td>
              <td>
                <img
                  style={{ width: 30 }}
                  src="https://storagemilforddev.blob.core.windows.net/images/realtor.svg"
                  alt=""
                />
                <img
                  style={{ width: 50 }}
                  src="https://storagemilforddev.blob.core.windows.net/images/eh.svg"
                  alt=""
                />
              </td>
            </tr>
          </tbody>
        </table>
      </td>
    </tr>
    <tr>
      <td style={{ padding: "15px 0px" }}>
        <span style={{ fontSize: 30, fontWeight: 700 }}>
          Multiple Offer Addendum
        </span>
      </td>
    </tr>
    <tr>
      <td style={{ padding: "15px 0px" }}>
        <span>
          This addendum is in addition to and becomes a permanent part of the
          Purchase Agreement dated
          <input
            type="date"
            value={multipleoffer?.agreement_date}
            onChange={(e)=>setMultipleoffer({...multipleoffer,agreement_date:e.target.value})}
            style={{
              outline: "none",
              border: "none",
              borderBottom: "1px solid black",
              width: 200
            }}
          />
          on the property known as
          <input
            type="text"//@ts-ignore
            value={offerdetails?.propertyAddress}
            // onChange={(e)=>setMultipleoffer({...multipleoffer,known_as:e.target.value})}
            style={{
              outline: "none",
              border: "none",
              borderBottom: "1px solid black",
              width: "80%"
            }}
          />
        </span>
      </td>
    </tr>
    <tr>
      <td>
        <span>Purchase Agreement to be amended as follows:</span>
      </td>
    </tr>
    <tr>
      <td style={{ padding: "15px 0px 15px 30px" }}>
        <span>
          1. In the event of multiple offers on this property, Buyer will match
          a competing net offer{" "}
          <span style={{ fontWeight: 600 }}>
            {" "}
            (meaning net proceeds to the Seller inclusive of any seller paid
            costs of buyer or buyer paid costs of the seller unless otherwise
            stated){" "}
          </span>
          and increase this net proceeds offer to Seller by
          <input
            type="text"
            value={multipleoffer?.seller_by}
            onChange={(e)=>setMultipleoffer({...multipleoffer,seller_by:e.target.value})}
            style={{
              outline: "none",
              border: "none",
              borderBottom: "1px solid black",
              width: "40%"
            }}
          />
          and:
        </span>
      </td>
    </tr>
    <tr>
      <td style={{ padding: "15px 0px 15px 60px" }}>
        <span>
          <input type="checkbox" 
             checked={multipleoffer?.up_maximum}
             onChange={(e)=>setMultipleoffer({...multipleoffer,up_maximum:!multipleoffer?.up_maximum})}
          /> UP to a maximum purchase price of ${" "}
          <input
            type="text"
            value={multipleoffer?.up_maximum_price_of}
            onChange={(e)=>setMultipleoffer({...multipleoffer,up_maximum_price_of:e.target.value})}
            style={{
              outline: "none",
              border: "none",
              borderBottom: "1px solid black",
              width: "40%"
            }}
          />
        </span>
      </td>
    </tr>
    <tr>
      <td style={{ padding: "15px 0px 15px 60px" }}>
        <span>
          <input type="checkbox" 
             checked={multipleoffer?.an_unlimited}
             onChange={(e)=>setMultipleoffer({...multipleoffer,an_unlimited:!multipleoffer?.an_unlimited})}
          />
          An <span style={{ fontWeight: 600 }}>UNLIMITED </span>maximum purchase
          price subject to Buyer's final approval of price within
          <input
            type="text"
            value={multipleoffer?.an_unlimited_hourof}
            onChange={(e)=>setMultipleoffer({...multipleoffer,an_unlimited_hourof:e.target.value})}
            style={{
              outline: "none",
              border: "none",
              borderBottom: "1px solid black",
              width: "10%"
            }}
          />
          hours of seller's notification of final price.{" "}
        </span>
      </td>
    </tr>
    <tr>
      <td style={{ padding: "15px 0px 15px 30px" }}>
        <span>
          If competing offer has waived radon inspection, Buyer waives radon
          inspection. If competing offer has waived a home warranty, buyer
          waives home warranty (subject to the following clause 2)
        </span>
      </td>
    </tr>
    <tr>
      <td style={{ padding: "15px 0px 15px 30px" }}>
        <span>
          2. This clause is <input type="checkbox" 
             checked={multipleoffer?.selected}
             onChange={(e)=>setMultipleoffer({...multipleoffer,selected:!multipleoffer?.selected})} 
          /> selected or{" "}
          <input type="checkbox" 
            checked={multipleoffer?.not_selected}
            onChange={(e)=>setMultipleoffer({...multipleoffer,not_selected:!multipleoffer?.not_selected})} 
          />
          not selected:
        </span>
      </td>
    </tr>
    <tr>
      <td>
        <span>
          Buyer's final price shall be increased by the amount of ${" "}
          <input
            type="text"
            value={multipleoffer?.final_price_amount}
            onChange={(e)=>setMultipleoffer({...multipleoffer,final_price_amount:e.target.value})}
            style={{
              outline: "none",
              border: "none",
              borderBottom: "1px solid black",
              width: "10%"
            }}
          />
          over and above the maximum purchase price determined in paragraph 1,
          to allow for Seller to purchase at closing a home warranty for Buyer
          through:
        </span>
      </td>
    </tr>
    <tr>
      <td style={{ padding: "15px 0px 15px 60px" }}>
        <span>
          <input type="checkbox" 
              checked={multipleoffer?.american_home_shield}
              onChange={(e)=>setMultipleoffer({...multipleoffer,american_home_shield:!multipleoffer?.american_home_shield})}
          />
          American Home Shield <input type="checkbox" 
          
          checked={multipleoffer?.two_ten_home_warranty}
          onChange={(e)=>setMultipleoffer({...multipleoffer,two_ten_home_warranty:!multipleoffer?.two_ten_home_warranty})}/>
          2-10 Home Warranty <input type="checkbox" 
             checked={multipleoffer?.other}
             onChange={(e)=>setMultipleoffer({...multipleoffer,other:!multipleoffer?.other})}
          />
          Other:{" "}
          <input
            type="text"
            value={multipleoffer?.other_value}
            onChange={(e)=>setMultipleoffer({...multipleoffer,other_value:e.target.value})}
            style={{
              outline: "none",
              border: "none",
              borderBottom: "1px solid black",
              width: "40%"
            }}
          />
        </span>
      </td>
    </tr>
    <tr>
      <td>
        <span>
          If the Property does not appraise due to the purchase of the home
          warranty, then this clause shall be automatically removed and the
          purchase price lowered to the maximum purchase price determined in
          paragraph 1 above.{" "}
        </span>
      </td>
    </tr>
    <tr>
      <td style={{ padding: "15px 0px 15px 30px" }}>
        <span>
          3. Seller shall promptly deliver to Buyer or Buyer's agent the fully
          executed Purchase Agreement reflecting the increased price as well as
          a copy of the highest competing offer with net sheet (without
          revealing the identity of the competing buyers).{" "}
        </span>
      </td>
    </tr>
    <tr>
      <td style={{ padding: "15px 0px 15px 30px" }}>
        <span>
          4. Disclaimer: Buyer acknowledges and affirms that this Multiple Offer
          Addendum has been made of Buyer's own volition and at Buyer's own
          discretion and Buyer agrees to hold agents and their Brokers harmless
          with regard to negotiation of the final sales price. In the event
          other Competing Offers are presented on this Property, Buyer
          acknowledges that a non-identifying copy of the documents constituting
          this Offer may be provided to the parties making such other offers.
        </span>
      </td>
    </tr>
    <tr>
      <td style={{ padding: "15px 0px" }}>
        <table style={{width:"100%"}}>
          <tbody>
            <tr>
              <td style={{width:"40%"}}>
              <span style={{ paddingRight: ".5rem" }}> Seller</span>
                <span style={{ paddingRight: ".5rem" }}>
                  <img
                  src={user === "seller" ? (val || multipleoffer?.seller1_signature) : multipleoffer?.seller1_signature}  
                    style={{
                      outline: "none",
                      border: "none",
                      borderBottom: "2px solid #3b0083",
                      width: 100
                    }}
                  />
                </span>
                
                <input
            type="date"
            value={multipleoffer?.seller1_signature_date ? multipleoffer?.seller1_signature_date  : (user === "seller" && val || multipleoffer?.seller1_signature) ? new Date().toISOString().split('T')[0] : ""}
            onChange={(e)=>setMultipleoffer({...multipleoffer,seller1_signature_date:e.target.value})}
            style={{
              outline: "none",
              border: "none",
              borderBottom: "1px solid black",
              width: "25%"
            }}
          />
                Date
              </td>
              <td style={{width:"40%"}}>
              <span style={{ paddingRight: ".5rem" }}> Buyer </span>
                <span style={{ paddingRight: ".5rem" }}>
                  <img
 src={user === "client" ? (val || multipleoffer?.buyer1_signature) : multipleoffer?.buyer1_signature}                    
                    style={{
                      outline: "none",
                      border: "none",
                      borderBottom: "2px solid #3b0083",
                      width: 100
                    }}
                  />
                </span>
                
                <input
            type="date"
            value={multipleoffer?.buyer1_signature_date ? multipleoffer?.buyer1_signature_date  : (user === "client" && val || multipleoffer?.buyer1_signature) ? new Date().toISOString().split('T')[0] : ""}
            onChange={(e)=>setMultipleoffer({...multipleoffer,buyer1_signature_date:e.target.value})}
            style={{
              outline: "none",
              border: "none",
              borderBottom: "1px solid black",
              width: "25%"
            }}
          />
                Date
              </td>
            </tr>
          </tbody>
        </table>
      </td>
    </tr>
    <tr>
      <td style={{ padding: "15px 0px" }}>
        <table style={{width:"100%"}}>
          <tbody>
            <tr>
              <td style={{width:"40%"}}>
              <span style={{ paddingRight: ".5rem" }}> Seller</span>
                <span style={{ paddingRight: ".5rem" }}>
                  <img
                    src={multipleoffer?.seller2_signature}
                    style={{
                      outline: "none",
                      border: "none",
                      borderBottom: "2px solid #3b0083",
                      width: 100
                    }}
                  />
                </span>
                
                <input
            type="date"
            value={multipleoffer?.seller2_signature_date}
            onChange={(e)=>setMultipleoffer({...multipleoffer,seller2_signature_date:e.target.value})}
            style={{
              outline: "none",
              border: "none",
              borderBottom: "1px solid black",
              width: "25%"
            }}
          />
                Date
              </td>
              <td style={{width:"40%"}}>
              <span style={{ paddingRight: ".5rem" }}> Buyer </span>
                <span style={{ paddingRight: ".5rem" }}>
                  <img
                    src={multipleoffer?.buyer2_signature}
                    style={{
                      outline: "none",
                      border: "none",
                      borderBottom: "2px solid #3b0083",
                      width: 100
                    }}
                  />
                </span>
                
                <input
            type="date"
            value={multipleoffer?.buyer2_signature_date}
            onChange={(e)=>setMultipleoffer({...multipleoffer,buyer2_signature_date:e.target.value})}
            style={{
              outline: "none",
              border: "none",
              borderBottom: "1px solid black",
              width: "25%"
            }}
          />
                Date
              </td>
            </tr>
          </tbody>
        </table>
      </td>
    </tr>
    <tr>
      <td style={{ padding: "50px 0px" }}>
        <span>
          Other provisions: Earnest deposit to be delivered within (5) business
          days
        </span>
      </td>
    </tr>
  </tbody>
</table>
 
<React.Fragment>
<div className="d-flex align-items-center justify-content-end mb-2 mr-2">
    <button onClick={send} className="btn primaryColorBtn">Submit
    {loader && <CSpinner color="dark" size="sm" className={'ml-1'} />}
    </button>
    <button onClick={printf} className="btn print-doc-btn mx-2">Print</button>
    <button className="signaturebtn btn mb-0" onClick={() => setCanvasModal()}>Signature</button> 
</div>
          </React.Fragment>

  <Esign
        canvasmodal={canvasmodal}
        setCanvasModal={setCanvasModal}
        htmlContent={htmlContent}
        setHtmlContent={setHtmlContent}
        selecteddocumentesign={selecteddocumentesign}
        setselectedDocumentEsign={setselectedDocumentEsign}
        type={"seller"}
      ></Esign>
        </>
    )
}

export default ALAmultipleoffer